import React from 'react'

export default function BasicInformationSection({
  formData,
  errors,
  handleInputChange,
  isFieldDisabled,
}) {
  return (
    <div className="form-section">
      <h3>Basic Information</h3>
      <div className="form-group">
        <label htmlFor="name">League Name*</label>
        <input
          id="name"
          name="name"
          type="text"
          value={formData.name}
          onChange={handleInputChange}
          className={errors.name ? 'error' : ''}
          disabled={isFieldDisabled('name')}
          title={
            isFieldDisabled('name')
              ? `Cannot change name in ${formData.league_status} status`
              : ''
          }
        />
        {errors.name && <span className="error-message">{errors.name}</span>}
      </div>

      <div className="form-row">
        <div className="form-group">
          <label htmlFor="league_type">League Type*</label>
          <select
            id="league_type"
            name="league_type"
            value={formData.league_type}
            onChange={handleInputChange}
            className={errors.league_type ? 'error' : ''}
            disabled={isFieldDisabled('league_type')}
            title={
              isFieldDisabled('league_type')
                ? `Cannot change league type in ${formData.league_status} status`
                : ''
            }
          >
            <option value="">Select Type</option>
            <option value="Singles">Singles</option>
            <option value="Doubles">Doubles</option>
            <option value="Mixed">Mixed</option>
          </select>
          {errors.league_type && (
            <span className="error-message">{errors.league_type}</span>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="age_category">Age Category*</label>
          <select
            id="age_category"
            name="age_category"
            value={formData.age_category}
            onChange={handleInputChange}
            className={errors.age_category ? 'error' : ''}
            disabled={isFieldDisabled('age_category')}
            title={
              isFieldDisabled('age_category')
                ? `Cannot change age category in ${formData.league_status} status`
                : ''
            }
          >
            <option value="">Select Category</option>
            <option value="Junior">Junior</option>
            <option value="Adult">Adult</option>
            <option value="Senior">Senior</option>
          </select>
          {errors.age_category && (
            <span className="error-message">{errors.age_category}</span>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="gender">Gender</label>
          <select
            id="gender"
            name="gender"
            value={formData.gender}
            onChange={handleInputChange}
            className={errors.gender ? 'error' : ''}
            disabled={isFieldDisabled('gender')}
            title={
              isFieldDisabled('gender')
                ? `Cannot change gender in ${formData.league_status} status`
                : ''
            }
          >
            <option value="">Select Gender</option>
            <option value="Men">Men</option>
            <option value="Women">Women</option>
            <option value="Mixed">Mixed</option>
          </select>
          {errors.gender && (
            <span className="error-message">{errors.gender}</span>
          )}
        </div>
      </div>
    </div>
  )
}
